<div id="relogin-view">
    <div id="datevReloginHandlingContainer" tabindex="-1">

        <div *ngIf="(currentState | async) === states.STARTED">
            <div class="pb-1x">
                <em class="icon relogin-handling-error-icon float-left mr-2x"></em>
                <h1 id="relogin-header">{{ 'relogin.started.header' | translate }}</h1>
            </div>
            <div class="pb-8x">
                <p>  {{ 'relogin.started.body' | translate }}</p>
            </div>
            <div>
                <button (click)="relogin()" class="btn btn-md btn-primary">
                    {{ 'relogin.started.footer' | translate }}
                </button>
            </div>
        </div>
        <div *ngIf="(currentState | async) === states.ERROR">
            <div>
                <em class="icon relogin-handling-error-icon"></em>
                <h2 class="pl-2 mt-1">{{ 'relogin.error.header' | translate }}</h2>
            </div>
            <div>
                <div>{{ 'relogin.error.body.label1' | translate }}</div>
                <div>{{ 'relogin.error.body.label2' | translate }}</div>
            </div>
            <div>
                <button (click)="close()" class="btn btn-md btn-primary">{{ 'relogin.error.footer' | translate }}</button>
            </div>
        </div>

    </div>
</div>

